export default __webpack_public_path__ + "static/media/Graphic-Assets2.59d166dd.jpg";